<div class="configuration-wrapper">
  <div class="configuration">
    <br />
    <form [formGroup]="form" *ngIf="form">
      <div class="form-content">
        <mat-form-field appearance="fill" color="primary" class="form-field-full-width">
          <mat-label>Device</mat-label>
          <mat-select panelClass="users-select-panel" formControlName="device">
            <mat-option>
              <ngx-mat-select-search
                placeholderLabel="Buscar..."
                noEntriesFoundLabel="No se encontraron coincidencias"
                [formControl]="devicesFiltroCtrl"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let device of devicesFiltrados | async" [value]="device.id">
              {{ device.selectLabel }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="fill" color="primary" class="form-field-full-width">
          <mat-label>Command</mat-label>
          <mat-select panelClass="users-select-panel" formControlName="command">
            <mat-option>
              <ngx-mat-select-search
                placeholderLabel="Buscar..."
                noEntriesFoundLabel="No se encontraron coincidencias"
                [formControl]="commandsFiltroCtrl"
              ></ngx-mat-select-search>
            </mat-option>
            <mat-option *ngFor="let command of commandsFiltrados | async" [value]="command.id">
              {{ command.selectLabel }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="fill"
          color="primary"
          class="form-field-full-width"
          *ngIf="form.get('command')?.value"
        >
          <mat-label>{{ dynamicInputLabel }}</mat-label>
          <input matInput formControlName="dynamicInput" />
        </mat-form-field>

        <ngx-recaptcha2
          [siteKey]="siteKey"
          formControlName="recaptcha"
          (success)="handleCaptchaSuccess($event)"
          (error)="handleCaptchaError($event)"
        ></ngx-recaptcha2>

        <mat-checkbox formControlName="termsAccepted" class="terms-checkbox">
          I have read and accept the terms and conditions of <a class="usage-policy-link" (click)="openUsagePolicyDialog($event)">usage policy.</a>
        </mat-checkbox>

        <button
          mat-raised-button
          color="primary"
          class="run-button"
          [disabled]="!form.valid || isLoading"
          (click)="ejecutarComando()">
          <div class="button-content">
            <mat-spinner *ngIf="isLoading" diameter="24" color="accent"></mat-spinner>
            <span>Run</span>
          </div>
        </button>
      </div>
    </form>

    <div class="response-wrapper" *ngIf="apiOutput !== null">
        <div class="console-output">
            <pre>{{ apiOutput }}</pre>
        </div>

        <button mat-stroked-button color="primary" class="reset-button" (click)="resetearFormulario()">
          Reset
        </button>
    </div>

    </div>

</div>

